import { Box } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import ConfirmationModal from "@/components/app/ConfirmationModal";
import Text from "@/components/Text";
import PayersCount from "./components/PayersCount";
import PayersTable from "./components/PayersTable";
import UpsertPayerDrawer from "./components/UpsertPayerDrawer";
import { usePayerActions } from "./hooks/use-payer-actions";
import { usePayersData } from "./hooks/use-payers-data";
import { PayersControls } from "./hooks/use-payers-controls";
import { PAYER_MESSAGES } from "./payers-constant";
import { getPayerPermissions } from "./payers-utils";

const Payers = () => {
  const { payersControls: controls }: { payersControls: PayersControls } =
    useOutletContext();
  const { drawer } = controls;
  const data = usePayersData(controls);
  const {
    confirmation,
    confirmationCopy,
    statusConfirmation,
    statusCopy,
    onAction,
    onConfirm,
    onStatusRequest,
    onStatusConfirm,
  } = usePayerActions(drawer);
  const permissions = getPayerPermissions();

  return (
    <Box width="100%">
      <PayersCount
        totalCount={data.totalCount}
        filteredCount={data.filteredCount}
        isFiltered={controls.hasActiveFilters}
      />
      {data.isError && (
        <Text c="error.main" my={1}>
          {PAYER_MESSAGES.LOAD_FAILED}
        </Text>
      )}
      <Box height="calc(100vh - 24rem)" mt={1}>
        <PayersTable
          rows={data.rows}
          rowCount={data.filteredCount}
          isLoading={data.isLoading}
          isArchivedView={controls.isArchivedView}
          permissions={permissions}
          pagination={controls.pagination}
          sortModel={controls.sortModel}
          onPaginationChange={controls.onPaginationChange}
          onSortModelChange={controls.onSortModelChange}
          onAction={onAction}
          onStatusRequest={onStatusRequest}
        />
      </Box>

      {drawer.opened && (
        <UpsertPayerDrawer
          open={drawer.opened}
          preFillValues={drawer.data?.values}
          onClose={drawer.close}
        />
      )}

      <ConfirmationModal
        disclosureHost={confirmation}
        title={confirmationCopy?.title}
        content={confirmationCopy?.content}
        confirmationText={confirmationCopy?.confirmText}
        onConfirm={onConfirm}
      />
      <ConfirmationModal
        disclosureHost={statusConfirmation}
        title={statusCopy?.title}
        content={statusCopy?.content}
        confirmationText={statusCopy?.confirmText}
        onConfirm={onStatusConfirm}
      />
    </Box>
  );
};

export default Payers;
